import Text from '../../../../components/Text'

const SectionHeader = ({ pageObj }) => {
  return (
    <>
      {pageObj?.title || pageObj?.subTitle ? (
        <div className="space-y-3 pb-0">
          {pageObj?.title ? (
            <Text
              tag="h2"
              variant="headline"
              size="small"
              className="text-[#101828]"
            >
              {pageObj?.title}
            </Text>
          ) : null}
          {pageObj?.subTitle ? (
            <Text
              tag="p"
              variant="body"
              size="medium"
              className="text-[#475467]"
              dangerouslySetInnerHTML={{ __html: pageObj?.subTitle }}
            />
          ) : null}
        </div>
      ) : null}
    </>
  )
}

export default SectionHeader
